/* ==========================================================================
   MX theme – mx-search.js   <mx-search-hero> (sections/mx-main-search.liquid)
     • shows the shopper's own words (the budget-aware search passes them as mx_ask) in the heading and the box
     • reads the lowest price of the results from Shopify (the same search sorted by price, first result)
     • suggestion chips search through the budget parser
     • follows MX Collection products: when its filters change the results, this part is fetched again for
       the new address so the counts, departments and top matches always agree with the grid
   ========================================================================== */
(function () {
  'use strict';
  if (customElements.get('mx-search-hero')) return;
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }

  class MXSearchHero extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.sid = this.getAttribute('data-section-id');
      this.applyAsk();
      this.lowest(window.location.href);
      this.onClick = function (e) {
        var a = e.target.closest('[data-mxs-ask]');
        if (!a || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !(window.MXTheme && MXTheme.search)) return;
        e.preventDefault();
        window.location.assign(MXTheme.search.url(a.getAttribute('data-mxs-ask')));
      };
      this.onUpdated = function (e) { if (e.detail && e.detail.url) self.refresh(e.detail.url); };
      this.addEventListener('click', this.onClick);
      document.addEventListener('mx:collection:updated', this.onUpdated);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('mx:collection:updated', this.onUpdated);
      if (this.abort) { try { this.abort.abort(); } catch (e) { /* noop */ } }
    }
    /* the words the shopper typed, budget included ("under 3 lakh" became a price filter) */
    applyAsk() {
      var ask = new URL(window.location.href).searchParams.get('mx_ask');
      if (!ask) return;
      document.querySelectorAll('[data-mxs-q]').forEach(function (el) { el.textContent = ask; });
      var input = this.querySelector('[data-mxa-input]');
      if (input && document.activeElement !== input) input.value = ask;
    }
    lowest(href) {
      var self = this;
      var from = this.querySelector('[data-mxs-from]');
      var slot = this.querySelector('[data-mxs-min]');
      if (!from || !slot || !Number(this.getAttribute('data-total'))) return;
      var u = new URL(href, window.location.href);
      u.searchParams.set('sort_by', 'price-ascending');
      u.searchParams.delete('page');
      u.searchParams.set('section_id', this.sid);
      fetch(u.toString(), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var m = /data-mxs-first="([^"]*)"/.exec(html);
          if (!m || !self.isConnected) return;
          slot.textContent = decode(m[1]);
          from.hidden = false;
        })
        .catch(function () { /* the sentence simply has no lowest price */ });
    }
    refresh(href) {
      var self = this;
      if (this.abort) { try { this.abort.abort(); } catch (e) { /* noop */ } }
      this.abort = 'AbortController' in window ? new AbortController() : null;
      var u = new URL(href, window.location.href);
      u.searchParams.set('section_id', this.sid);
      fetch(u.toString(), { credentials: 'same-origin', signal: this.abort ? this.abort.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-mxs-dynamic]');
          var mine = self.querySelector('[data-mxs-dynamic]');
          var root = doc.querySelector('mx-search-hero');
          if (!fresh || !mine) return;
          /* everything is replaced except the search box, which never moves (the shopper may be typing in it) */
          var imported = document.importNode(fresh, true);
          var main = mine.querySelector('.mxq__main'), fmain = imported.querySelector('.mxq__main');
          var box = main && main.querySelector('.mxq__box');
          if (!main || !fmain || !box) { mine.replaceWith(imported); }
          else {
            var kids = Array.prototype.slice.call(fmain.children);
            var at = kids.findIndex(function (k) { return k.classList.contains('mxq__box'); });
            Array.prototype.slice.call(main.children).forEach(function (c) { if (c !== box) c.remove(); });
            kids.forEach(function (k, i) { if (i === at) return; if (at === -1 || i > at) main.appendChild(k); else main.insertBefore(k, box); });
            Array.prototype.slice.call(mine.children).forEach(function (c) { if (c !== main) c.remove(); });
            Array.prototype.slice.call(imported.children).forEach(function (c) { if (!c.classList.contains('mxq__main')) mine.appendChild(c); });
          }
          self.classList.add('is-updated');
          if (root) self.setAttribute('data-total', root.getAttribute('data-total'));
          self.applyAsk();
          self.lowest(href);
        })
        .catch(function () { /* keep what is shown */ });
    }
  }
  customElements.define('mx-search-hero', MXSearchHero);
})();
